import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IEventsItem } from 'store/slices/events/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadEventsItem,
  saveEventsItem,
  saveEventsItemAsDraft,
} from 'store/slices/events/actions';

import { EventsForm } from './components/EventsForm/EventsForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.events);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { b2cUrl } = useAppSelector(state => state.configSlice);

  React.useEffect(() => {
    dispatch(loadEventsItem(id));
  }, []);

  const onFinish = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/events');
  };

  const getOgSiteName = () => {
    if (!item) return null;

    const sysName = item.sysName || '';
    const linkToB2C =
      item.lang === 'en'
        ? `${b2cUrl}/en/events/${id}/${sysName}`
        : `${b2cUrl}/events/${id}/${sysName}`;

    return linkToB2C;
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <EventsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === 'draft'}
          isLoading={isLoading}
          initialValues={{
            ...mapValuesToForm(item),
            ogUrl: getOgSiteName(),
            ogSiteName: 'Посети Кавказ',
            ogType: 'events',
          }}
        />
      ) : null}
    </MainLayout>
  );
};
